import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e497528a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-12 member-h" }, "ポイント履歴")
], -1))
const _hoisted_2 = { class: "row current-point mt-5 mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, "ご利用可能ポイント", -1))
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "blue" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "pt", -1))
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ポイント購入", -1))
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "pt", -1))
const _hoisted_12 = {
  key: 1,
  class: "row"
}
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ポイント利用", -1))
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = { class: "blue" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "pt", -1))

import { Member, PaymentMethod, PointHistory } from '@/models';
import { Auth, DataStore, SortDirection } from 'aws-amplify';
import {ref, reactive, inject, onMounted, toRefs, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router';

import dayjs from 'dayjs'
import 'dayjs/locale/ja'

interface Props {
  member: Member;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null
  },
  emits: ['stopLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
}

const route = useRoute();
const router = useRouter();



const { member } = toRefs(props);



const histories = ref();
const activeYearMonth = ref();

watch(member, async() => {
  try {    
    const list = await DataStore.query(PointHistory,
      (p) => p.memberID('eq', member.value.id),
      {
        sort: p => p.createdAt(SortDirection.DESCENDING)
      });

    histories.value = {};
    activeYearMonth.value = {};

    list.forEach(x => {
      const yearMonth = dayjs(x.createdAt).format('YYYY/MM');
      if (!histories.value[yearMonth]) {
        histories.value[yearMonth] = [];
      }
      histories.value[yearMonth].push(x);
      activeYearMonth.value[yearMonth] = false;
    });

    const currentYearMonth = dayjs().format('YYYY/MM');
    if (activeYearMonth.value[currentYearMonth]) {
      activeYearMonth.value[currentYearMonth] = true;
    }

  }
  catch(e){
    console.log(e);
    router.push('/');
  }

  emit('stopLoading');
});

const getCode = () => {
  return ('000000' + member.value.codeNum).slice(-6);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(member).point?.toLocaleString()), 1),
        _hoisted_6
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(histories.value, (yearMonthList, yearMonth) => {
      return (_openBlock(), _createElementBlock("div", { key: yearMonth }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearMonthList, (history, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "point-history",
            key: idx
          }, [
            (history.addPoint && history.addPoint > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(history.createdAt).format('YYYY/MM/DD HH:mm')), 1),
                    _hoisted_9
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", null, "+" + _toDisplayString(history.addPoint?.toLocaleString()), 1),
                    _hoisted_11
                  ])
                ]))
              : _createCommentVNode("", true),
            (history.usePoint && history.usePoint > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(history.createdAt).format('YYYY/MM/DD HH:mm')), 1),
                    _hoisted_14
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, "-" + _toDisplayString(history.usePoint?.toLocaleString()), 1),
                    _hoisted_17
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    }), 128))
  ], 64))
}
}

})